import getLectureList from "./getLectureList";
import createLecture from "./createLecture";
import getLecture from "./getLecture";
import changeStatus from "./changeStatus";
import updateLecture from "./updateLecture";
import deleteLecture from "./deleteLecture";

export default {
  getLectureList,
  createLecture,
  getLecture,
  changeStatus,
  updateLecture,
  deleteLecture,
};
